export default "__VITE_ASSET__BxbNZw0L__"